import React, { Fragment, useEffect } from 'react';

import Select from 'react-select';
import { Dropdown as PrimeReactDropDown } from 'primereact/dropdown';
import { handleEnterKey } from 'utils/utils';


const Dropdown: React.FC<any> = (props): JSX.Element => {
    const { value, className, label, helperText, prime, id, ...passThroughProps } = props;

    useEffect(() => {
        const elements = Array.from(document.getElementsByClassName("p-dropdown"));
        if (elements) {
            for (const element of elements) {
                element.getElementsByTagName("input")[0].readOnly = true;
            }
        }
    }, []);


    return (
        <div className={`${className} mb-5`}>
            {label &&
                <label className="d-block mb-2">
                    {label}
                </label>
            }
            {prime ?
                <PrimeReactDropDown
                    className="w-100"
                    value={value || ""}
                    {...passThroughProps}
                />
                :
                <Select
                    defaultValue={value || ""}
                    name={id}
                    noOptionsMessage={() => "opção não encontrada"}
                    className="w-100"
                    onKeyDown={(event) => handleEnterKey(event, id)}
                    {...passThroughProps}
                />
            }
            {helperText && (value ?
                <p className="pt-1 font-weight-bold secondary-text reduced-letter-spacing">
                    {helperText}
                </p> :
                <Fragment>
                    &nbsp;
                </Fragment>)
            }
        </div>
    );
}

export default Dropdown;
